// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__VJTlv","row":"ProcedureTreatmentSummary_row__1ChPS"};